import { ColumnDef } from "@tanstack/react-table";
import { Checkbox } from "@/core/components/ui/checkbox";
import { Stack } from "@/core/components/ui/stack";

export const createSelectionColumn = <TData,>(): ColumnDef<TData, unknown> => ({
  id: "select",
  header: ({ table }) => {
    const isAllSelected = table.getIsAllRowsSelected();
    const isSomeSelected = table.getIsSomeRowsSelected();

    return (
      <Stack
        direction="row"
        justify="center"
        align="center"
        className="min-h-12 pr-4"
        fullWidth
        onClick={(e) => {
          e.stopPropagation();
          table.getToggleAllRowsSelectedHandler()(e);
        }}
      >
        <Checkbox
          checked={isAllSelected}
          indeterminate={isSomeSelected}
          onCheckedChange={(checked) => {
            // Create a synthetic event that TanStack Table expects
            const syntheticEvent = {
              target: { checked: checked === true },
            } as React.ChangeEvent<HTMLInputElement>;

            table.getToggleAllRowsSelectedHandler()(syntheticEvent);
          }}
          aria-label="Select all rows"
        />
      </Stack>
    );
  },
  cell: ({ row }) => (
    <Stack
      direction="row"
      justify="center"
      align="center"
      className="min-h-[4.5rem] pl-2"
      fullWidth
      onClick={(e) => {
        e.stopPropagation();
        row.getToggleSelectedHandler()(e);
      }}
    >
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={row.getToggleSelectedHandler()}
        disabled={!row.getCanSelect()}
        aria-label="Select row"
      />
    </Stack>
  ),
  size: 40,
  minSize: 40,
  maxSize: 40,
  enableSorting: false,
  enableColumnFilter: false,
  enableHiding: false,
});
